import { Navigate } from 'react-router-dom';
import { useAccount } from '@/app/common/hooks/useAccount.ts';
import LoadingSpinner from '@/app/common/components/LoadingSpinner.tsx';
import type { ReactNode } from 'react';

export default function EditorRoute({ children }: { children: ReactNode }) {
  const { loaded, canWrite } = useAccount();

  if (!loaded) {
    return <LoadingSpinner />;
  }

  if (!canWrite) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
}
